type Amount<C> = Readonly<{ value: number; currencyId: C }>;

export type MatrixTotal<C = string> = Readonly<{
  undiscountedAmountExcludingVat: Amount<C>;
  discountAsAmount: Amount<C>;
  discountedAmountExcludingVat: Amount<C>;
  vatAsAmount: Amount<C>;
  discountedAmountIncludingVat: Amount<C>;
}>;

export type TotalAmountKey = keyof MatrixTotal;

const TOTAL_AMOUNT_KEYS: readonly TotalAmountKey[] = [
  'undiscountedAmountExcludingVat',
  'discountAsAmount',
  'discountedAmountExcludingVat',
  'vatAsAmount',
  'discountedAmountIncludingVat',
];

export const isZeroTotal = <C>(
  total: MatrixTotal<C> | null | undefined,
): boolean =>
  !total || TOTAL_AMOUNT_KEYS.every((key) => total[key].value === 0);

export const computeTotalDifferences = <C>(
  manualTotal: MatrixTotal<C>,
  automaticTotal: MatrixTotal<C>,
): ReadonlyMap<TotalAmountKey, Amount<C>> =>
  new Map(
    TOTAL_AMOUNT_KEYS.map((key) => [
      key,
      {
        value: manualTotal[key].value - automaticTotal[key].value,
        currencyId: manualTotal[key].currencyId,
      },
    ]),
  );
